/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import {
    Box,
    Button,
    FormControl,
    FormErrorMessage,
    FormLabel
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

/* Internal Imports */
/* Components */
import InputUI from '@components/Elements/InputUI';
import Recaptcha from '@components/UI/Subscribe/Recaptcha';
import config from '@config';

/* Services */
import { fetchReportPdf } from 'services/othersService';
// import { consoleLog } from '@components/Utility/Shared/SharedService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Page Data
 */

const FormReport = ({ id, setError, setPdf }) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values) => {
    setLoading(true);
    const object = {
      email: values.email,
      id: id,
    };

    const response = await fetchReportPdf(object);
    // consoleLog('response', response);
    if (!response.length) {
      setError('Server did not respond');
      setLoading(false);
    } else {
      // setTimeout(() => {
      setError('');
      setLoading(false);
      // consoleLog('response[0]', response[0]);
      setPdf(response[0]?.pdf_url);
      // }, 20000);
    }
  };

  const ReportFormSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/^[a-zA-Z]+[a-zA-Z0-9._]+@[a-zA-Z]+\.[a-zA-Z.]{2,15}$/, {
        message: 'Email is invalid',
      })
      // .email('Invalid email')
      .required('Email is required'),
    recaptcha: Yup.string().required('Cannot go past recaptcha'), // not required in dev only
  });

  return (
    <Box
      w={{ base: '90%', sm: '80%', md: '460px' }}
      //   maxWidth="480px"
      minW={'300px'}
      maxW="365px"
      m="50px auto"
      fontFamily="FedraSansStd-book"
      bgColor="rgb(0 0 0 / 30%)"
      padding="30px"
    >
      <Formik
        initialValues={{ email: '', recaptcha: '' }}
        validationSchema={ReportFormSchema}
        onSubmit={onSubmit}
      >
        {props => (
          <Form onSubmit={props.handleSubmit}>
            <Field name="email">
              {({ field, form }) => (
                <FormControl
                  isRequired
                  isInvalid={form.errors.email && form.touched.email}
                  maxWidth={{ md: '460px', sm: '460px', base: '300px' }}
                  width="100%"
                //   m={{ base: '0 0 18px 0', xl: '0' }}
                >
                  <FormLabel htmlFor="email" color="#676055" fontWeight="600">
                    Email
                  </FormLabel>
                  <InputUI
                    color="#000"
                    field={field}
                    id="email"
                    p="10px"
                    placeholder="Enter Email Id"
                    onChange={props.handleChange}
                  />
                  <FormErrorMessage justifyContent="left">
                    {form.errors.email}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Box marginTop="20px">
              <Field name="recaptcha">
                {({ form }) => (
                  <FormControl
                    isInvalid={form.errors.recaptcha && form.touched.recaptcha}
                  //   width={{ base: 'auto', xl: 'calc((100% - 40px)/3)' }}
                  //   m={{ base: '0 0 18px 0', xl: '0' }}
                  >
                    {config.RECAPTCHA_KEY && (
                      <Recaptcha props={props} sitekey={config.RECAPTCHA_KEY} />
                    )}
                    <FormErrorMessage justifyContent="left">
                      {form.errors.recaptcha}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </Box>
            <Box display="grid" placeContent="center" marginTop="20px">
              <Button
                type="submit"
                borderRadius={'20px'}
                fontWeight="400"
                // width="180px"
                lineHeight="30px"
                disabled={props.isValid ? (loading ? true : false) : true}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
      <style jsx global>{`
        ::placeholder {
          color: #a1a1a1;
        }
      `}</style>
    </Box>
  );
};

export default FormReport;
